import { render, staticRenderFns } from "./xiaofei_jilu.vue?vue&type=template&id=2bbccc64&scoped=true"
import script from "./xiaofei_jilu.vue?vue&type=script&lang=js"
export * from "./xiaofei_jilu.vue?vue&type=script&lang=js"
import style0 from "./xiaofei_jilu.vue?vue&type=style&index=0&id=2bbccc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbccc64",
  null
  
)

export default component.exports